import { useTheme } from "@mui/material";
import { clientTheme } from "../theme/clientTheme";

interface LogoProps {
  maxWidth?: string;
  maxHeight?: string;
}

export const Logo = ({
  maxWidth = clientTheme.branding.logoMaxWidth ?? "130px",
  maxHeight = clientTheme.branding.logoMaxHeight ?? "40px",
}: LogoProps) => {
  const theme = useTheme();
  const logo =
    theme.palette.mode === "dark"
      ? clientTheme.branding.logoDark
      : clientTheme.branding.logoLight;

  return (
    <img
      src={logo}
      alt={`${clientTheme.branding.appName} Logo`}
      style={{
        width: "100%",
        height: "auto",
        maxWidth,
        maxHeight,
      }}
    />
  );
};
